import * as THREE from "three";
import { CHAT_EVNET } from "./define";
import { BUS_EVENT, EventBus } from "../eventBus";
//启用缓存
THREE.Cache.enabled = true;
const JAWOPEN='jawOpen'
const viseme_map ={
    'PP':1,
    'FF':1,
    'TH':1,
    'DD':1,
    'kk':1,
    'CH':1,
    'SS':1,
    'nn':1,
    'RR':1,
    'aa':1,
    'E':1,
    'I':1,
    'O':1,
    'U':1,
    'sil':1,
    'jawOpen':1

}

const STATE_PLAY = {
    FREE: 0,
    PLAYING: 1,
    ENDED: 2
}
export class AudioPlayer {



    constructor() {
        this.audioListener = undefined;
        this.audioSound = undefined;
        this.bodyModel = undefined;
        this.phonemeJasonData = undefined;//音素数据
        this.morphControl = undefined;
        this.morphDict = undefined;
        this.nextFrame = 0;
        this.currentFrame = -1;
        this.currentFrameStartTime = 0;//当前口型开始时间
        this.startlayTime = 0;
        this.endTime = 0;
        this.eventHandler = undefined;
        this.statePlay = 0 //STATE_PLAY 0-未开始 1-播放中 2-播放结束
        //口型驱动相关参数
        this.exponent = 5;
        this.intensity = 0.8, //口型变化强度
        this.dec = 10;
        this.defStep = 0.07, //口型变化步长 会在initDefStep方法中重新初始化
        this.currentFrameDelyaTime=100//当前口型持续时间 会在initDefStep方法中重新初始化
        this.endDelay = 1000; //结束之后延时（嘴型还原时间）
    }
    /**
     * 加载音素数据
     * @param {*} url 
     */
    loadPhonemeData(url) {
        return new Promise((resolve, reject) => {
            const fileLoader = new THREE.FileLoader();
            fileLoader.load(url,
                data => {
                    resolve(data)
                },
                process => {

                },
                err => {
                    reject(err)
                }
            )
        })

    }
    /**
     * 设置监听回调
     * @param {} handler 
     */
    setEventListener(handler) {
        this.eventHandler = handler
    }
    /**
     * 发送事件
     * @param {*} event 
     * @param {*} data 
     */
    emitEvent(event, data) {
        console.log('emit event', event, data)
        if (this.eventHandler)
            this.eventHandler(event, data)
    }

    /**
     * 计算步长信息
     */
    initDefStep() {
        if (this.phonemeJasonData.length <= 1) {
            return
        }
        let timeTotal = 0;
        for (let i = 1; i < this.phonemeJasonData.length; ++i) {
            timeTotal += this.phonemeJasonData[i].time - this.phonemeJasonData[i - 1].time
        }
        this.currentFrameDelyaTime = timeTotal / this.phonemeJasonData.length - 1
        this.defStep = 1.0 / (60.0 / 1000 * this.currentFrameDelyaTime) //形态键最大值/(fps/1000毫秒*每个口型持续时间平均值)
    }
    startAudioCtx(startSec){
        if(this._source &&  this.audioCtxPlaying){
            this._source.stop()
        }
        this.audioCtxPlaying=true
        this._source && this._source.start(0,startSec ? startSec :0);
    }
    /**
     * 根据音频波形控制口行张合
     */
    initAudioCtx(audioUrl,startSec){

        let _sensitivityThreshold = .5;   
        const samplingFrequency = 44100;
        const _voiceBoundingFrequencies = [0, 500, 700, 3000, 6000];
        const _audioSampleCount = {low:256, med:512, high:1024};
        let _smoothing = 0.5; 
        const getstPSD = spectrum => {

           const stPSD = new Float32Array(spectrum.length);
   
           for (let i = 0 ; i< spectrum.length;i++) {
               stPSD[i]= _sensitivityThreshold + ((spectrum[i] +20)/140);	
           }
           
           return stPSD;
        }
        
       const _getData = url => {
           var request = new XMLHttpRequest();

           request.open('GET', url, true);
           request.responseType = 'arraybuffer';

           return new Promise(function (resolve, reject) {
               request.onload = function() {
                   var audioData = request.response;
                   resolve(audioData);
                   console.log('audioData',audioData)
                }

                request.send();
           });
       }

        let _sampleCount = _audioSampleCount.high;
        let _indicesFrequencyMale = [];
        let _analyser = this.audioCtx.createAnalyser();     
        this.audioCtxPlaying=false
        let _this = this
        _getData(audioUrl).then(audioData=>{
            _this.audioCtx.decodeAudioData(audioData, function(_buffer) {
                console.log('Buffer ready to play.');
               for( let m = 0 ; m < _voiceBoundingFrequencies.length ; m++) {
                   _indicesFrequencyMale[m] = Math.round(((2*_sampleCount)/samplingFrequency) *_voiceBoundingFrequencies[m]);
                   //console.log("IndicesFrequencyMale[",m,"]",_indicesFrequencyMale[m]);
               }
               _analyser.minDecibels = -160;
               _analyser.maxDecibels = -25;
               _analyser.smoothingTimeConstant = _smoothing;
               _analyser.fftSize = _sampleCount;
               
               _this._source = _this.audioCtx.createBufferSource()
               _this._source.buffer = _buffer;
               _this._source.connect(_analyser);
               const gainNode = _this.audioCtx.createGain();
               gainNode.connect(_this.audioCtx.destination);
               gainNode.gain.value = 0; // 设置音量为0
               _this._source.connect(gainNode)
               if(_this._node){
                _this._node.onaudioprocess=null
                _this._node = null
               }
               _this._node = _this.audioCtx.createScriptProcessor(_sampleCount*2, 1, 1);
               _analyser.connect(_this._node);
               _this._node.onaudioprocess = _ => {
                    if(!_this.audioCtxPlaying) return
                   // console.log('=============== process')
                   let _spectrum = new Float32Array(_analyser.frequencyBinCount);
                   _analyser.getFloatFrequencyData(_spectrum);
                   let _stPSD = getstPSD(_spectrum);
                   
                   let _blendShapeKiss = 0;
                   let _blendShapeLips = 0;
                   let _blendShapeMouth = 0;
       
                   let energyBinMale = new Float32Array(_voiceBoundingFrequencies.length);
       
                   for ( let m = 0 ; m < _voiceBoundingFrequencies.length -1 ; m++){
                       for ( let j = _indicesFrequencyMale[m]; j<= _indicesFrequencyMale[m+1]; j++) {
                           if(_stPSD[j] >0){
                               energyBinMale[m]+= _stPSD[j] ; 	
                           }
                       }
       
                       energyBinMale[m] /= (_indicesFrequencyMale[m+1] -_indicesFrequencyMale[m] ); 
                   }
       
                   if( energyBinMale[1] > 0.2 ) {
                       _blendShapeKiss = 1 -2*energyBinMale[2] ;
                   }else{
                       _blendShapeKiss = ( 1-2*energyBinMale[2])*5*energyBinMale[1];
                   }
       
                   _blendShapeLips = 3*energyBinMale[3];
                   _blendShapeMouth = 0.85*(energyBinMale[1]-energyBinMale[3]);
       
                   let _blendShapes = {
                       blendShapeKiss:_blendShapeKiss,
                       blendShapeLips:_blendShapeLips,
                       blendShapeMouth:_blendShapeMouth
                   }
                   _this.morphControl[_this.morphDict[JAWOPEN]] = _blendShapeMouth
                //    EventBus.$emit(BUS_EVENT.ADD_LOG,_blendShapeMouth)
               }	

               _this._node.connect(_this.audioCtx.destination);
               _this.audioCtxPlaying=true
               _this._source.start(0,startSec ? startSec :0);
               _this._source.onended = ()=>{
                    console.log('播放结束')
                    _this.audioCtxPlaying=false
                    _this.emitEvent(CHAT_EVNET.END_AUDIO)
                    _this._node.onaudioprocess=null
               }
               
            },err => {
                console.log("Error with decoding audio data:" + err);
                _this.emitEvent(CHAT_EVNET.END_AUDIO)
                reject(err);
            });
               
       },err => {
               console.log("Error with decoding audio data:" + err);
               reject(err);
       });
    }
    /**
     * 播放音频文件，并驱动口型
     * @param {人物模型} bodyModel
     * @param {音频文件地址} audioUrl 
     * @param {音素文件地址} phonemeUrl 
     */
    playAudio(bodyModel, audioUrl, phonemeData, textData, duration,conf) {
        return new Promise(async (resolve, reject) => {
            try {
                //停止正在播放的音频
                if (this.audioSound) {
                    this.audioSound.pause()
                }
                this.nextFrame = 0;
                this.currentFrame = -1;
                this.statePlay = STATE_PLAY.FREE
                bodyModel.scene.getObjectByName("Armature").traverse(o => {
                    if (o.morphTargetInfluences) {

                        this.morphControl = o.morphTargetInfluences
                        this.morphDict = o.morphTargetDictionary
                        console.log('找到形态键：', o.name, o.morphTargetDictionary)
                    }
                })
                //加载音素数据
                // const jsonData = await this.loadPhonemeData(phonemeUrl)
                if(this.audioCtx){
                    this.audioCtx.close()
                    delete this.audioCtx
                    this.audioCtx=null
                }
                this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();       


                this.phonemeJasonData = phonemeData
                this.textData = textData
                console.log('音素数据：', this.phonemeJasonData)
                if (this.phonemeJasonData.length == 0 || this.phonemeJasonData[0].type != 'viseme') {
                    this.emitEvent(CHAT_EVNET.ERROR_AUDIO, '无法识别的音素数据:' + (this.phonemeJasonData.length == 0 ? '数组长度为0' : ''))
                    reject("无法识别的音素数据")
                }
                this.initDefStep()
                console.log('计算出平均时长以及步长:', this.currentFrameDelyaTime, this.defStep)
                this.bodyModel = bodyModel


                //加载音频文件
                if (!this.audioSound) {
                    this.audioSound = new Audio()

                    
                }
                
                this.audioSound.preload='none'
                this.audioSound.addEventListener('error', (err) => {//开始播放
                    this.emitEvent(CHAT_EVNET.ERROR_AUDIO, '语音加载失败:' + audioUrl)
                    reject(err)
                })
                // this.audioSound.muted = true
                this.audioSound.src = audioUrl
                this.playDuration = duration //播放时长

                let startPlay=()=>{
                    console.log('-------can start play')
                    this.audioSound.removeEventListener('canplaythrough',startPlay)   
                    if(!this.isPlaying){
                        this.startPlayTime = Date.now() / 1000
                        this.isPlaying = true
                        this.isPlayMuted = false
                    }
                    
                    this.audioSound.currentTime = Date.now()/1000  - this.startPlayTime
                    this.audioSound.addEventListener('seeked',()=>{
                        console.log('----------seeked')
                        this.audioSound.muted=false
                        this.audioSound.play()
                       
                    })
                    this.initAudioCtx(audioUrl,this.audioSound.currentTime+0.1)
                }
                this.audioSound.removeEventListener('canplaythrough',startPlay)   
                this.audioSound.addEventListener('canplaythrough',startPlay)
                
                this.startlayTime = 0
                this.endTime = 0

                if(conf.muted){
                    this.emitEvent(CHAT_EVNET.MUTED_PLAY, '静音播放') 
                    this.startPlayTime = Date.now() / 1000
                    this.isPlaying = true
                    this.isPlayMuted = true
                }
                else{//自动开始播放
                    this.audioSound.muted=true //开始播放前静音，等加载完成后再开始播放声音
                    this.audioSound.load()  
                    this.audioCtx && this.audioCtx.resume() //激活audioctx
                }
                this.emitEvent(CHAT_EVNET.START_AUDIO, {
                    message: this.textData,
                    voiceDuration: this.phonemeJasonData.length > 0 ? this.phonemeJasonData[this.phonemeJasonData.length - 1].time : 0
                })
              
                    
             
                
            }
            catch (e) {
                console.error(e)
                reject('加载音频失败')
            }
        })
    }
    setAudioMuted(muted) {
        if (this.audioSound) {
            this.audioSound.muted = muted
        }
        if(!muted && this.isPlayMuted && this.isPlaying){ //当前静音假播放，定位到时间点
            this.audioSound.muted=true //开始播放前静音，等加载完成后再开始播放声音
            this.audioSound.play().then(()=>{
            },(e)=>{ 
                console.error('播放失败:',e)
            })
            this.audioCtx && this.audioCtx.resume() //激活resume
        }
    }
    currentTime() {
        return Date.now() / 1000 //this.startPlayTime+ this.currentPlayTime
    }
    //取消所有形态键
    decreaseAllVisemes() {
        for (let visemeName of Object.keys(this.morphDict)) {
            this.morphControl[this.morphDict[visemeName]] = 0
        }
    }
    nextViseme() {
        // console.log('current frame',this.currentFrame)
        if (
            this.currentFrame > 0 &&
            this.phonemeJasonData[this.currentFrame].value === this.phonemeJasonData[this.currentFrame-1].value
          ) {
            this.exponent -= 0.1;
          } else this.exponent = 10;
           // decrease all visemes
        for (var visemeName of Object.keys(this.morphDict)) {
    
            if (viseme_map[visemeName]) {
                this.morphControl[this.morphDict[visemeName]] -=
                    this.intensity / this.dec;
                if (this.morphControl[this.morphDict[visemeName]] < 0)
                    this.morphControl[this.morphDict[visemeName]] = 0;
            }
        }
        if(!this.isPlaying){
            return
        }
        if(this.currentFrame>=0 && this.currentFrame<this.phonemeJasonData.length){
            var visemeName = this.phonemeJasonData[this.currentFrame].value;
            let mapping={
                [visemeName]:1
            }
            for (var currentVisemeName of Object.keys(mapping)) {
            //   console.log('currentVisemeName pre',currentVisemeName,this.morphControl[this.morphDict[currentVisemeName]])
              if(this.morphControl[this.morphDict[currentVisemeName]]==undefined) continue
              // calculate the added value
              var inc = Math.pow(this.intensity, this.exponent);
              // check if the visime is relative
              if (mapping[currentVisemeName] > 1) inc /= 4;
            //   console.log('inc ',inc)
            //   console.log('increase 0',currentVisemeName,this.morphControl[this.morphDict[currentVisemeName]])
              // add the value
              this.morphControl[this.morphDict[currentVisemeName]] +=
                this.intensity / this.dec;
                // console.log('increase 1',currentVisemeName,this.morphControl[this.morphDict[currentVisemeName]])
              this.morphControl[this.morphDict[currentVisemeName]] += inc;
            //   console.log('increase 2',currentVisemeName,this.morphControl[this.morphDict[currentVisemeName]])
              // check constraints
              if (
                this.morphControl[this.morphDict[currentVisemeName]] > 1 &&
                mapping[currentVisemeName] > 1
              )
                this.morphControl[this.morphDict[currentVisemeName]] = 1;
              if (
                this.morphControl[this.morphDict[currentVisemeName]] >
                  mapping[currentVisemeName] * this.intensity &&
                !(mapping[currentVisemeName] > 1)
              )
                this.morphControl[this.morphDict[currentVisemeName]] =
                  mapping[currentVisemeName] * this.intensity;
            //   console.log('increase 3',currentVisemeName,this.morphControl[this.morphDict[currentVisemeName]])
            }
        }
        
        
        let nextFrame = this.currentFrame+1
        //  console.log('----1',nextFrame)
        if(nextFrame<this.phonemeJasonData.length){
            // console.log('----2')
            let nextVisemeData = this.phonemeJasonData[nextFrame]
            let nextTime = this.currentTime() * 1000 - this.startlayTime - 20 //-20为了提前驱动口型
            if (nextTime < 0) nextTime = 0
            // console.log('----3 nextTime',nextTime,nextVisemeData.time)
            if (nextTime >= nextVisemeData.time) {
                this.currentFrame = nextFrame
                this.currentFrameStartTime = this.currentTime() * 1000
            }
        }


    }
    updateAudioDelta() {
        return;
        if (this.isPlaying) {
            if (this.statePlay == STATE_PLAY.FREE) {
                this.startlayTime = this.currentTime() * 1000
               
                this.statePlay = STATE_PLAY.PLAYING;
            }
            this.nextViseme()
            //播放结束
            if(Date.now()/1000 - this.startPlayTime > this.playDuration){
                this.isPlaying=false
            }
        }
        else if (this.statePlay == STATE_PLAY.PLAYING) {
            if (this.startlayTime > 0) {
                if (this.endTime == 0)
                    this.endTime = Date.now()
                else if (Date.now() - this.endTime < this.endDelay)
                    this.nextViseme()
                else {
                    this.statePlay = STATE_PLAY.ENDED
                    this.emitEvent(CHAT_EVNET.END_AUDIO)
                    this.eventHandler = undefined
                }

            }
        }

    }
    stopNowVoice() {
        if (this.audioSound) this.audioSound.pause()
        this.audioCtxPlaying=false
        this.isPlaying=false
        this.emitEvent(CHAT_EVNET.END_AUDIO)
    }
    initAudioDict(bodyModel){
        bodyModel.scene.getObjectByName("Armature").traverse(o => {
            if (o.morphTargetInfluences) {

                this.morphControl = o.morphTargetInfluences
                this.morphDict = o.morphTargetDictionary
                console.log('找到形态键：', o.name, o.morphTargetDictionary)
            }
        })
        this.bodyModel = bodyModel
    }
    setJWAOpenValue(value){
        if(this.morphControl && this.morphDict){
            this.morphControl[this.morphDict[JAWOPEN]] = value
        }
        
    }
}



// WEBPACK FOOTER //
// ./src/S51WebGLSDK/audioPlayer.js